import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  LogoutOutlined,
  SnippetsOutlined,
  MenuOutlined,
  CloseOutlined,
  // ShopOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import {
  Badge,
  Button,
  Drawer,
  Image,
  Layout,
  Menu,
  Modal,
  Tag,
  theme,
  Tooltip,
} from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PermissionInfo, UserInfo } from "../../context";
import "./layout.css";
import AccountDetails from "../commissary/account/AccountDetails";

const { Header, Sider, Content, Footer } = Layout;

const CommissaryEmployeeLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(
    window.innerWidth > 600 ? false : true
  );
  const navtab =
    window.location.pathname === "/"
      ? "1"
      : window.location.pathname === "/po"
      ? "2"
      : window.location.pathname === "/po-my-process"
      ? "3"
      : "";
  // const navtab2 = window.location.pathname === "/po-my-process" ? "sub1" : "";
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const themeStyle = "dark";
  const [current, setCurrent] = useState("1");
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { handleLogoutTkn, userData } = useContext(UserInfo);
  const { permissionList, poList } = useContext(PermissionInfo);
  const [accountDetailsDrawer, setAccountDetailsDrawer] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);

  function getItem(label, key, icon, children, disabled, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
      disabled,
    };
  }

  const items = [
    getItem(
      <Link to="/" relative="path">
        Home
      </Link>,
      "1",
      <HomeOutlined />
    ),
    permissionList.ready &&
    permissionList.data.find(({ permission }) => permission === "acknowledge")
      ? getItem(
          "Purchase Order",
          "sub1",
          <SnippetsOutlined />,
          [
            getItem(
              <Link to="/po" relative="path">
                P.O List
                <Badge
                  count={poList.data.length}
                  // count={2}
                  size="small"
                  style={{ marginBottom: 20, marginLeft: 5 }}
                />
              </Link>,
              "2"
            ),
            getItem(
              <Link to="/po-my-process" relative="path">
                My Process
              </Link>,
              "3"
            ),
          ],
          permissionList.data.find(
            ({ permission }) => permission === "acknowledge"
          )
            ? false
            : true
        )
      : null,
  ];

  // const items = [
  //   {
  //     label: <Link relative="path">Purchase Order</Link>,
  //     key: "1",
  //     icon: <SnippetsOutlined />,
  //     disabled: permissionList.data.find(
  //       ({ permission }) => permission === "acknowledge"
  //     )
  //       ? false
  //       : true,
  //     children: [
  //       {
  //         label: (
  //           <Link to="/po" relative="path">
  //             PO List
  //           </Link>
  //         ),
  //         key: "sub1",
  //       },
  //       {
  //         label: (
  //           <Link to="/po-my-process" relative="path">
  //             My Process
  //           </Link>
  //         ),
  //         key: "sub2",
  //         // icon: <SnippetsOutlined />,
  //       },
  //     ],
  //   },
  // ];

  const MenuonClick = (e) => {
    setCurrent(e.key);
  };

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setOpen(false);
      setConfirmLoading(false);
      handleLogoutTkn();
    }, 2000);
  };

  useEffect(() => {}, [current]);

  return (
    <Layout
      style={{ minHeight: "100vh" }}
      hasSider={window.innerWidth > 500 ? true : false}
    >
      {window.innerWidth > 500 && (
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          style={{
            overflow: "auto",
            height: "100vh",
            position: "fixed",
            left: 0,
            top: 0,
            bottom: 0,
            background: themeStyle === "dark" ? "#001529" : "#fff",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                height: collapsed ? 45 : 100,
                width: collapsed ? 45 : 100,
                margin: 16,
                background: themeStyle === "dark" ? "transparent" : "#001529",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Image
                width={"auto"}
                height={collapsed ? 45 : 100}
                src={
                  userData.data.userscomemployee.business_logo !== null
                    ? `${process.env.REACT_APP_API_IMAGE}logo/${userData.data.userscomemployee.business_logo}`
                    : require("./../../assets/logo.png")
                }
                placeholder={"logo"}
                preview={false}
              />
            </div>
          </div>

          {/* <Menu
            onClick={MenuonClick}
            defaultSelectedKeys={[navtab]}
            theme={themeStyle}
            items={items}
            // mode="inline"
            inlineCollapsed={collapsed}
          /> */}

          {/* <Menu
            defaultSelectedKeys={[navtab]}
            defaultOpenKeys={["sub1"]}
            mode="inline"
            theme="dark"
            inlineCollapsed={collapsed}
            items={items}
          /> */}

          <Menu
            defaultSelectedKeys={[navtab]}
            defaultOpenKeys={["sub1"]}
            mode="inline"
            theme="dark"
            // inlineCollapsed={collapsed}
            items={items}
          />
        </Sider>
      )}

      <Layout
        className="container3"
        style={{
          marginLeft: window.innerWidth > 500 ? (collapsed ? 80 : 200) : 0,
        }}
      >
        <Header
          style={{
            padding: 0,
            background: colorBgContainer,
          }}
        >
          <div style={{ display: "flex" }}>
            <div style={{ flexGrow: 1 }}>
              {window.innerWidth > 500 ? (
                collapsed ? (
                  <MenuUnfoldOutlined
                    style={{ marginLeft: 10, fontSize: 15 }}
                    className="trigger"
                    onClick={() => setCollapsed(!collapsed)}
                  />
                ) : (
                  <MenuFoldOutlined
                    style={{ marginLeft: 10, fontSize: 15 }}
                    className="trigger"
                    onClick={() => setCollapsed(!collapsed)}
                  />
                )
              ) : (
                <MenuOutlined
                  style={{ marginLeft: 10, fontSize: 15 }}
                  className="trigger"
                  onClick={() => setOpenDrawer(!openDrawer)}
                />
              )}
              <Tag
                icon={<UserOutlined />}
                color="#f50"
                style={{ marginLeft: 10 }}
              >
                Employee
              </Tag>
            </div>

            <div style={{ marginRight: 20 }}>
              {/* <Tooltip
                placement="bottomRight"
                title={"Account"}
                color={"#2db7f5"}
              >
                <UserOutlined
                  style={{ marginRight: 15, fontSize: 15 }}
                  className="trigger"
                  onClick={() => {
                    setAccountDetailsDrawer(true);
                  }}
                />
              </Tooltip> */}
              <Tooltip
                placement="bottomRight"
                title={"Logout"}
                color={"#2db7f5"}
              >
                <LogoutOutlined
                  style={{ fontSize: 15 }}
                  className="trigger"
                  onClick={() => setOpen(true)}
                />
              </Tooltip>
            </div>
          </div>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
            overflow: "initial",
          }}
        >
          {children}
        </Content>
        <Footer
          style={{
            textAlign: "center",
            fontWeight: "bold",
            width: "100%",
            position: "inherit",
            marginBottom: 0,
          }}
        >
          BBMS ©2023 Created by Nehemiah Solutions
        </Footer>
      </Layout>

      <Drawer
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
        placement="left"
        closable={false}
        bodyStyle={{ backgroundColor: "#001529" }}
        width={220}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div style={{ flexGrow: 1 }}></div>
          <div>
            <Tooltip title="Close">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setOpenDrawer(false);
                }}
                style={{ color: "#fff", backgroundColor: "#001529" }}
                icon={<CloseOutlined />}
              />
            </Tooltip>
          </div>
        </div>
        <Menu
          onClick={MenuonClick}
          defaultSelectedKeys={[navtab]}
          theme={themeStyle}
          items={items}
        />
      </Drawer>

      <Modal
        title="Are you sure to logout?"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setOpen(false)}
      />

      {accountDetailsDrawer && (
        <AccountDetails
          open={accountDetailsDrawer}
          close={() => setAccountDetailsDrawer(false)}
        />
      )}
    </Layout>
  );
};
export default CommissaryEmployeeLayout;
